/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExportServiceRecordsGet$Params {
  ids?: Array<string>;
}

export function apiExcelExportServiceRecordsGet(http: HttpClient, rootUrl: string, params?: ApiExcelExportServiceRecordsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExportServiceRecordsGet.PATH, 'get');
  if (params) {
    rb.query('ids', params.ids, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/zip', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExportServiceRecordsGet.PATH = '/api/Excel/Export_ServiceRecords';
